<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import CustomLoader from "@/components/widgets/custom-loader";
import CustomFilter from "@/components/widgets/custom-filter";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Marks for Sets and Subjects",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    CustomLoader,
    CustomFilter,
  },
  data() {
    return {
      title: "Filter per Sets and Subjects",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Marks for Sets and Subjects",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "student",
          label: "Student's Name",
          sortable: true,
        },
        {
          key: "stream",
          label: "Stream",
          sortable: true,
        },
        {
          key: "sets_marks",
          label: "Marks",
          sortable: true,
        },
      ],
      setSubjectMarks: {
        class: "",
        term: "",
        year: "",
        subject: "",
        set: "",
        stream: "",
      },
    };
  },
  computed: {
    ...mapGetters("marks", [
      "SaveStatus",
      "getSpecMarksFilters",
      "getCurrentSet",
      "getCurrentClass",
      "getCurrentSub",
      "getYears",
    ]),
    ...mapGetters("classes", [
      "AllClasses",
      "GetClassSubjects",
      "AllClassStreams",
    ]),
    ...mapGetters("coursework", ["AllSets"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.getSpecMarksFilters.length
        ? this.getSpecMarksFilters.length
        : 1;
    },
  },
  watch: {
    SaveStatus(newVal) {
      if (!newVal) {
        this.resetError();
        // this.closeModal(this.modal);
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows =
      this.getSpecMarksFilters.length > 0 ? this.getSpecMarksFilters.length : 1;
  },
  methods: {
    ...mapActions({
      FetchSpecMarksFilters: "marks/fetchSpecMarksFilters",
      FetchClassSubjects: "classes/fetchClassSubjects",
      FetchClassStreams: "classes/fetchClassStreams",
      FetchSets: "coursework/fetchSets",
      FetchYears: "marks/fetchYear",
      FetchClasses: "classes/fetchClasses",
      FetchStreams: "classes/fetchStreams",
    }),

    fetchStreamsinClass(event) {
      const id = event.target.value;
      const classSelected = { id };
      //fetching class streams
      this.FetchClassStreams(classSelected);
    },

    fetchClassSub(event) {
      const id = event.target.value;
      const classSelected = { id };
      //fetching class subjects
      this.FetchClassSubjects(classSelected);
    },

    fetchStreamsSubject(event) {
      this.fetchStreamsinClass(event);
      this.fetchClassSub(event);
    },

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.getSpecMarksFilters.length
        ? this.getSpecMarksFilters.length
        : 1;
      this.currentPage = 1;
    },

    submitSetSubjectMarks() {
      this.FetchSpecMarksFilters(this.setSubjectMarks);
    },

    resetError() {
      this.nameError = "";
    },
  },
  created() {
    this.FetchYears();
    this.FetchClasses();
    this.FetchStreams();
    this.FetchSets();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('advanced_marks_reports')
        )
      "
    >
      <CustomFilter>
        <form @submit.prevent="submitSetSubjectMarks()">
          <div class="row">
            <div class="form-group col-md-3 mb-2">
              <div class="form-group">
                <label for=""
                  >Select Year <small class="text-danger">*</small></label
                >
                <select
                  class="form-control form-control-sm"
                  v-model="setSubjectMarks.year"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Year</option>
                  <option
                    v-for="(schyear, index) in getYears"
                    :value="schyear.year"
                    :key="index"
                  >
                    {{ schyear.year }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-3 mb-2">
              <div class="form-group">
                <label for=""
                  >Select Class <small class="text-danger">*</small></label
                >
                <select
                  required
                  class="form-control form-control-sm"
                  v-model="setSubjectMarks.class"
                  @change="fetchStreamsSubject($event)"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Class</option>
                  <option
                    v-for="(classes, index) in AllClasses"
                    :key="index"
                    :value="classes.id"
                  >
                    {{ classes.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-3 mb-2">
              <div class="form-group">
                <label for=""
                  >Select Term <small class="text-danger">*</small></label
                >
                <select
                  required
                  class="form-control form-control-sm"
                  v-model="setSubjectMarks.term"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Term</option>
                  <option value="1">Term 1</option>
                  <option value="2">Term 2</option>
                  <option value="3">Term 3</option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-3 mb-2">
              <div class="form-group">
                <label for="">Select Exam Set</label>
                <select
                  required
                  class="form-control form-control-sm"
                  v-model="setSubjectMarks.set"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Exam Set</option>
                  <option
                    v-for="(set, index) in AllSets"
                    :key="index"
                    :value="set.id"
                  >
                    {{ set.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-3 mb-2">
              <div class="form-group">
                <label for="">Select Subject</label>
                <select
                  required
                  class="form-control form-control-sm"
                  v-model="setSubjectMarks.subject"
                  name=""
                  id=""
                >
                  <option value="" selected disabled v-if="SaveStatus">
                    Fetching Subjects...
                  </option>
                  <option value="" selected disabled v-else>
                    Select Subject
                  </option>
                  <option
                    v-for="(subject, index) in GetClassSubjects"
                    :key="index"
                    :value="subject.id"
                  >
                    {{ subject.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-3 mb-2">
              <div class="form-group">
                <label for=""
                  >Select Stream
                  <small class="text-primary">(Optional)</small></label
                >
                <select
                  class="form-control form-control-sm"
                  v-model="setSubjectMarks.stream"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Stream</option>
                  <option
                    v-for="(stream, index) in AllClassStreams"
                    :value="stream.id"
                    :key="index"
                  >
                    {{ stream.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-3 mt-4">
              <button
                type="submit"
                disabled
                class="btn btn-sm btn-outline-primary mt-1"
                v-if="SaveStatus"
              >
                <b-spinner
                  variant="primary"
                  small
                  label="Fetching Data..."
                ></b-spinner>
                Fetching Data...
              </button>
              <button
                v-else
                type="submit"
                size="sm"
                class="btn btn-sm btn-outline-primary mt-1"
              >
                <i class="fa fa-check"></i>
                Submit Filers
              </button>
            </div>
          </div>
        </form>
      </CustomFilter>
      <CustomLoader v-if="SaveStatus"></CustomLoader>
      <div class="col-12" v-else>
        <div class="card" v-if="getSpecMarksFilters">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  Exam Marks, Term
                  <b
                    ><u>{{ setSubjectMarks.term }}</u></b
                  >
                  Class:
                  <b
                    ><u>{{ getCurrentClass.short }}</u></b
                  >
                  Subject:
                  <b
                    ><u>{{ getCurrentSub.short }}</u></b
                  >
                  Test:
                  <b
                    ><u>{{ getCurrentSet.short }}</u></b
                  >
                  Year:
                  <b
                    ><u>{{ setSubjectMarks.year }}</u></b
                  >
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-md-12 mt-4 custom-vert">
                    <div class="row mt-2">
                      <div class="col-sm-12 col-md-6">
                        <div
                          id="tickets-table_length"
                          class="dataTables_length"
                        >
                          <label class="d-inline-flex align-items-center">
                            Show&nbsp;
                            <b-form-select
                              class="form-select form-select-sm"
                              v-model="perPage"
                              size="sm"
                              :options="pageOptions"
                            ></b-form-select
                            >&nbsp;entries
                          </label>
                        </div>
                      </div>

                      <div class="col-sm-12 col-md-6">
                        <div
                          id="tickets-table_filter"
                          class="dataTables_filter text-md-end"
                        >
                          <label class="d-inline-flex align-items-center">
                            Search:
                            <b-form-input
                              v-model="filter"
                              type="search"
                              placeholder="Search..."
                              class="form-control form-control-sm ms-2"
                            ></b-form-input>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="table-responsive mb-0">
                      <b-table
                        class="datatables"
                        :items="getSpecMarksFilters"
                        :fields="fields"
                        responsive="sm"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        @filtered="onFiltered"
                      >
                        <template #cell(index)="data">
                          {{ data.index + 1 }}
                        </template>
                        <template #cell(student)="data">
                          {{ data.item.student.name }}
                        </template>
                        <template #cell(stream)="data">
                          {{ data.item.stream.name }}
                        </template>
                        <template #cell(sets_marks)="data">
                          {{ data.item.sets_marks.marks }}
                        </template>
                      </b-table>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div
                          class="
                            dataTables_paginate
                            paging_simple_numbers
                            float-end
                          "
                        >
                          <ul class="pagination pagination-rounded mb-0">
                            <b-pagination
                              v-model="currentPage"
                              :total-rows="rows"
                              :per-page="perPage"
                            ></b-pagination>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-else>
          <div class="card-body">
            <div class="alert alert-primary text-center" role="alert">
              <strong>Please filter students using the above inputs.</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
